var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32625 13.3333L2.55482 3.63533C2.29233 2.96036 2.95049 2.31487 3.60157 2.54431L3.70417 2.58793L23.7042 12.5879C24.28 12.8758 24.316 13.6642 23.8121 14.0147L23.7042 14.0786L3.70417 24.0786C3.05642 24.4025 2.35275 23.807 2.52089 23.1375L2.55482 23.0312L6.32625 13.3333L2.55482 3.63533L6.32625 13.3333ZM4.89123 5.04485L7.79011 12.4993L15.1541 12.5C15.576 12.5 15.9246 12.8135 15.9798 13.2202L15.9874 13.3333C15.9874 13.7552 15.6739 14.1038 15.2672 14.159L15.1541 14.1666L7.79011 14.166L4.89123 21.6217L21.4681 13.3333L4.89123 5.04485Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.06a2ebddbe77c4138e4524a697defb8f.svg";
export { ForwardRef as ReactComponent };